import {cn} from '@cohort/shared-frontend/utils/classNames';
import type {ReactElement} from 'react';
import {cloneElement} from 'react';

export const contentVisualPreviewEmptyImageElement = (
  icon: ReactElement,
  className?: string
): JSX.Element => (
  <div
    className={cn(
      'flex aspect-video h-full w-full items-center justify-center rounded-[--xps-img-border-radius] bg-[--xps-card-background-color]',
      className
    )}
  >
    {cloneElement(icon, {size: 80, className: 'text-[--xps-border-color]'})}
  </div>
);

export const contentVisualPreviewImageElement = (
  title: string,
  imageSrc: string,
  className?: string
): JSX.Element => {
  return (
    <img
      title={title}
      className={cn(
        'aspect-video h-full w-full rounded-[--xps-img-border-radius] object-cover',
        className
      )}
      draggable="false"
      src={imageSrc}
    />
  );
};
